module.exports = __webpack_public_path__ + "img/motors-pattern.0c2acb97.png";